export class Form {
  constructor(form) {
    this.form = form
    this.submitWrapper = this.form.querySelector('.form__submit')
    this.submitButton = this.form.querySelector('[type=submit]')
    this.fetchUrl = this.form.getAttribute('action')
    this.errorMessage = null
    this.handleSubmit = this.handleSubmit.bind(this)

    this.form.addEventListener('submit', this.handleSubmit)
  }

  disableForm() {
    this.submitButton.setAttribute('disabled', 'disabled')
    this.form.setAttribute('disabled', 'disabled')
  }

  enableForm() {
    this.submitButton.removeAttribute('disabled')
    this.form.removeAttribute('disabled')
  }

  clearMessage() {
    if (this.errorMessage) {
      this.form.removeChild(this.errorMessage)
      this.errorMessage = null
    }
  }

  showMessage(message, error = false) {
    const cssClasses = ['form__helper', 'notice']
    if (error) {
      cssClasses.push('error')
      cssClasses.push('form__helper--error')
    } else {
      cssClasses.push('updated')
    }

    this.errorMessage = document.createElement('div')
    this.errorMessage.className = cssClasses.join(' ')
    this.errorMessage.innerHTML = `<p>${message}</p>`

    this.form.insertBefore(this.errorMessage, this.submitWrapper)
  }

  success(data) {
    const { message = '', redirect = '', reset = false } = data
    document.dispatchEvent(new CustomEvent('form-success'))

    if (message) {
      this.showMessage(message)
    }

    if (reset) {
      this.form.reset()
    }

    if (redirect) {
      window.location.href = redirect
    }
  }

  error(data) {
    const { message } = data
    this.showMessage(`Error: ${message}`, true)
    document.dispatchEvent(new CustomEvent('form-error'))
  }

  async handleSubmit(e) {
    e.preventDefault()

    if (!this.fetchUrl) {
      throw new Error('Form - No action parameter specified')
    }

    const formData = new FormData(this.form)
    const { sitekey = '', recaptcha = '' } = window.suplementos

    if (sitekey && window.grecaptcha && recaptcha === 'v3') {
      await window.grecaptcha
        .execute(sitekey, { action: 'submit' })
        .then(token => {
          formData.append('g-recaptcha-response', token)
        })
    }

    this.clearMessage()
    this.disableForm()

    const response = await fetch(this.fetchUrl, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    })
      .then(res => res.json())
      .catch(error => ({ message: error }))

    if (response.error) {
      this.error(response)
    } else {
      this.success(response)
    }

    this.enableForm()
  }
}

const formInit = {
  // eslint-disable-next-line consistent-return
  init(selector = '.form') {
    const wrapperEl = document.querySelectorAll(selector)
    Array.from(wrapperEl).forEach(form => new Form(form))
  },
}

export default formInit
